function Email({email}){
  return(
     <div className="email">{email}</div>
  );
}

export default Email;

